import I18n from 'I18n';
import { LIST_OPERATORS, LIST_OPERATORS_BY_FIELD_TYPE, TIMEPOINT_ENDPOINT_BEHAVIOUR } from 'FormsUI/constants/ListOperators';
import { FALLBACK_TYPES, DEFAULT_FILTER_BRANCH, MAX_FIELDS_ALLOWED, MAX_ROUTING_LISTS_PER_POLICY, DEFAULT_INPUT_VALUES, RESET_REDIRECT, ROUTE_TYPE, ROUTE_STATE, PROPERTY_PARSER } from 'FormsUI/constants/Routing';
import FieldTypes from 'forms-utils-lib/constants/formField/FieldType';
import updateItemInArray from 'forms-utils-lib/utils/array/updateItemInArray';
import removeItemFromArray from 'forms-utils-lib/utils/array/removeItemFromArray';
import addItemToArray from 'forms-utils-lib/utils/array/addItemToArray';
import { getStartAndNextDayTimePoints } from 'FormsUI/utils/DateUtils';
import { isValidUrl } from 'FormsUI/utils/UrlUtils';
import { FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
import flatten from 'hs-lodash/flatten';
export const getPolicyPropertyIdentifier = policy => {
  if (policy.routingPolicyList.length > 0) {
    const {
      objectTypeId,
      propertyName
    } = policy.routingPolicyList[0].routingPolicyFilter;
    if (objectTypeId && propertyName) {
      return `${objectTypeId}/${propertyName}`;
    }
    return undefined;
  }
  return undefined;
};
export const getIsPolicyTicketProperty = policy => {
  if (policy.routingPolicyList.length > 0) {
    const {
      objectTypeId
    } = policy.routingPolicyList[0].routingPolicyFilter;
    if (objectTypeId === FormFieldPropertyObjectTypesIds.TICKET) {
      return true;
    }
    return false;
  }
  return false;
};
export const splitPolicyPropertyIdentifier = identifier => identifier.split('/');
export const getRoutingPolicyAtIndex = (routingPolicy, index) => routingPolicy && routingPolicy.length > index ? routingPolicy[index] : undefined;
const getRoutingPolicyListAtIndex = (routingPolicy, routingPolicyIndex, routingListIndex) => {
  const routingPolicyToUpdate = getRoutingPolicyAtIndex(routingPolicy, routingPolicyIndex);
  return routingPolicyToUpdate && routingPolicyToUpdate.routingPolicyList.length > routingListIndex ? routingPolicyToUpdate.routingPolicyList[routingListIndex] : undefined;
};
export const setFallbackType = (redirect, fallbackType) => {
  if (fallbackType === FALLBACK_TYPES.INLINE_MESSAGE) {
    return Object.assign({}, redirect, {
      defaultRouteType: FALLBACK_TYPES.INLINE_MESSAGE,
      defaultRouteValue: I18n.text('defaultForm.thankYouMessage')
    });
  } else {
    return Object.assign({}, redirect, {
      defaultRouteType: fallbackType,
      defaultRouteValue: undefined
    });
  }
};
export const setFallbackValue = (redirect, value) => {
  return Object.assign({}, redirect, {
    defaultRouteValue: value
  });
};
export const setRouteState = (redirect, state) => {
  return Object.assign({}, redirect, {
    routeState: state
  });
};
export const getRouteContainsConditions = redirect => Boolean(redirect.routingPolicyGroup.length);
export const setRoutingToggled = (redirect, routingEnabled) => {
  if (!routingEnabled) {
    return setRouteState(redirect, ROUTE_STATE.DISABLED);
  }
  if (getRouteContainsConditions(redirect)) {
    return setRouteState(redirect, ROUTE_STATE.CONDITIONAL_ROUTE);
  }
  const simpleRoute = setRouteState(redirect, ROUTE_STATE.SIMPLE_ROUTE);
  return setFallbackType(simpleRoute, FALLBACK_TYPES.MEETING);
};
export const setRoutingPolicyProperty = (redirect, index, identifier) => {
  const {
    routingPolicyGroup
  } = redirect;
  const routingPolicyToUpdate = getRoutingPolicyAtIndex(routingPolicyGroup, index);
  const [objectTypeId, propertyName] = splitPolicyPropertyIdentifier(identifier);
  if (routingPolicyToUpdate) {
    const defaultRoutingPolicy = getRoutingPolicyListAtIndex(routingPolicyGroup, index, 0);
    const currentRouteType = defaultRoutingPolicy ? defaultRoutingPolicy.routeType : DEFAULT_FILTER_BRANCH.routeType;
    const currentRouteValue = defaultRoutingPolicy ? defaultRoutingPolicy.routeValue : DEFAULT_FILTER_BRANCH.routeValue;
    const newRoutingPolicy = Object.assign({}, routingPolicyToUpdate, {
      routingPolicyList: [Object.assign({}, DEFAULT_FILTER_BRANCH, {
        routeType: currentRouteType,
        routeValue: currentRouteValue,
        routingPolicyFilter: Object.assign({}, DEFAULT_FILTER_BRANCH.routingPolicyFilter, {
          objectTypeId,
          propertyName
        })
      })]
    });
    const newRoutingPolicyGroup = updateItemInArray(routingPolicyGroup, index, newRoutingPolicy);
    return Object.assign({}, redirect, {
      routingPolicyGroup: newRoutingPolicyGroup
    });
  }
  return redirect;
};
export const getBranchDefaultOperation = (operator, type, fieldType, currentPropertyFilterOperator) => {
  const propertyType = LIST_OPERATORS_BY_FIELD_TYPE[fieldType][operator];
  let operation;
  if (operator === LIST_OPERATORS.IS_KNOWN || operator === LIST_OPERATORS.IS_UNKNOWN) {
    operation = {};
  } else {
    switch (type) {
      case FieldTypes.DATE:
      case FieldTypes.DATE_TIME:
        {
          const {
            startOfDayTimePoint,
            endOfNextDayTimePoint
          } = getStartAndNextDayTimePoints();
          let propertyParser;
          if (type === FieldTypes.DATE_TIME) {
            propertyParser = PROPERTY_PARSER.VALUE;
          } else {
            propertyParser = PROPERTY_PARSER.VALUE_WITH_ZONE_SAME_LOCAL_CONVERSION;
          }
          switch (operator) {
            case LIST_OPERATORS.IS_BETWEEN:
            case LIST_OPERATORS.IS_NOT_BETWEEN:
              operation = {
                propertyParser,
                lowerBoundTimePoint: currentPropertyFilterOperator.lowerBoundTimePoint || startOfDayTimePoint,
                upperBoundTimePoint: currentPropertyFilterOperator.upperBoundTimePoint || endOfNextDayTimePoint,
                lowerBoundEndpointBehavior: TIMEPOINT_ENDPOINT_BEHAVIOUR.INCLUSIVE,
                upperBoundEndpointBehavior: TIMEPOINT_ENDPOINT_BEHAVIOUR.INCLUSIVE
              };
              break;
            case LIST_OPERATORS.IS_LESS_THAN_X_DAYS_AGO:
            case LIST_OPERATORS.IS_LESS_THAN_X_DAYS_FROM_NOW:
            case LIST_OPERATORS.IS_MORE_THAN_X_DAYS_AGO:
            case LIST_OPERATORS.IS_MORE_THAN_X_DAYS_FROM_NOW:
              operation = {
                propertyParser,
                numberOfDays: currentPropertyFilterOperator.numberOfDays || DEFAULT_INPUT_VALUES.WITHIN_TIME
              };
              break;
            default:
              operation = {
                propertyParser,
                timePoint: currentPropertyFilterOperator.timePoint || startOfDayTimePoint
              };
              break;
          }
          break;
        }
      case FieldTypes.ENUMERATION:
        operation = {
          values: currentPropertyFilterOperator.values || DEFAULT_INPUT_VALUES.ENUMERATION
        };
        break;
      case FieldTypes.NUMBER:
        switch (operator) {
          default:
            operation = {
              value: currentPropertyFilterOperator.value || DEFAULT_INPUT_VALUES.NUMBER
            };
            break;
        }
        break;
      default:
        operation = {
          values: currentPropertyFilterOperator.values || DEFAULT_INPUT_VALUES.STRING
        };
        break;
    }
  }
  return Object.assign({
    operator,
    propertyType
  }, operation);
};
export const getReorderedRoutingPolicy = (redirect, sourceIndex, targetIndex) => {
  const {
    routingPolicyGroup
  } = redirect;
  if (targetIndex < 0 || targetIndex > routingPolicyGroup.length) {
    return redirect;
  }
  let reorderedRoutingPolicy;
  const baseRoutingPolicy = routingPolicyGroup[sourceIndex];
  reorderedRoutingPolicy = addItemToArray(routingPolicyGroup, targetIndex, baseRoutingPolicy);
  const newSourceIndex = sourceIndex < targetIndex ? sourceIndex : sourceIndex + 1;
  reorderedRoutingPolicy = removeItemFromArray(reorderedRoutingPolicy, newSourceIndex);
  return Object.assign({}, redirect, {
    routingPolicyGroup: reorderedRoutingPolicy
  });
};
export const setRoutingListKey = (redirect, routingPolicyIndex, routingListIndex, key, value) => {
  const {
    routingPolicyGroup
  } = redirect;
  const routingPolicyToUpdate = getRoutingPolicyAtIndex(routingPolicyGroup, routingPolicyIndex);
  const routingListToUpdate = getRoutingPolicyListAtIndex(routingPolicyGroup, routingPolicyIndex, routingListIndex);
  if (routingPolicyToUpdate && routingListToUpdate) {
    const newFilterBranch = Object.assign({}, routingListToUpdate, {
      routeValue: key === 'routeType' ? undefined : routingListToUpdate.routeType,
      [key]: value
    });
    const newBranches = updateItemInArray(routingPolicyToUpdate.routingPolicyList, routingListIndex, newFilterBranch);
    const newPolicy = Object.assign({}, routingPolicyToUpdate, {
      routingPolicyList: newBranches
    });
    const newRoutingPolicyGroup = updateItemInArray(routingPolicyGroup, routingPolicyIndex, newPolicy);
    return Object.assign({}, redirect, {
      routingPolicyGroup: newRoutingPolicyGroup
    });
  }
  return redirect;
};
export const setRoutingFilterKey = (redirect, routingPolicyIndex, routingListIndex, key, value) => {
  const {
    routingPolicyGroup
  } = redirect;
  const routingPolicyToUpdate = getRoutingPolicyAtIndex(routingPolicyGroup, routingPolicyIndex);
  const routingListToUpdate = getRoutingPolicyListAtIndex(routingPolicyGroup, routingPolicyIndex, routingListIndex);
  if (routingPolicyToUpdate && routingListToUpdate) {
    const newFilterBranch = Object.assign({}, routingListToUpdate, {
      routingPolicyFilter: Object.assign({}, routingListToUpdate.routingPolicyFilter, {
        [key]: value
      })
    });
    const newBranches = updateItemInArray(routingPolicyToUpdate.routingPolicyList, routingListIndex, newFilterBranch);
    const newPolicy = Object.assign({}, routingPolicyToUpdate, {
      routingPolicyList: newBranches
    });
    const newRoutingPolicyGroup = updateItemInArray(routingPolicyGroup, routingPolicyIndex, newPolicy);
    return Object.assign({}, redirect, {
      routingPolicyGroup: newRoutingPolicyGroup
    });
  }
  return redirect;
};
export const setRoutingListValue = (redirect, routingPolicyIndex, routingListIndex, value) => {
  const {
    routingPolicyGroup
  } = redirect;
  const routingListToUpdate = getRoutingPolicyListAtIndex(routingPolicyGroup, routingPolicyIndex, routingListIndex);
  if (routingListToUpdate) {
    const currentOperation = routingListToUpdate.routingPolicyFilter.propertyFilterOperation;
    return Object.assign({}, currentOperation, value);
  }
  return undefined;
};
export const addNewRoutingPolicy = redirect => {
  const {
    routingPolicyGroup
  } = redirect;
  if (routingPolicyGroup.length < MAX_FIELDS_ALLOWED) {
    const newRoutingPolicyGroup = {
      routingPolicyList: [DEFAULT_FILTER_BRANCH]
    };
    return Object.assign({}, redirect, {
      routingPolicyGroup: [...routingPolicyGroup, newRoutingPolicyGroup]
    });
  }
  return redirect;
};
export const removeRoutingPolicy = (redirect, routingPolicyIndex) => {
  const {
    routingPolicyGroup
  } = redirect;
  const newRoutingPolicyGroup = removeItemFromArray(routingPolicyGroup, routingPolicyIndex);
  if (newRoutingPolicyGroup.length === 0) {
    return Object.assign({}, redirect, RESET_REDIRECT);
  }
  return Object.assign({}, redirect, {
    routingPolicyGroup: newRoutingPolicyGroup
  });
};
export const removeRoutingPolicies = (redirect, indicesToRemove) => {
  if (indicesToRemove.length === 0) return redirect;
  const {
    routingPolicyGroup
  } = redirect;
  const newRoutingPolicyGroup = routingPolicyGroup.filter((_, index) => !indicesToRemove.includes(index));
  if (newRoutingPolicyGroup.length === 0) {
    return Object.assign({}, redirect, RESET_REDIRECT);
  }
  return Object.assign({}, redirect, {
    routingPolicyGroup: newRoutingPolicyGroup
  });
};
export const removeRoutingList = (redirect, routingPolicyIndex, routingListIndex) => {
  const {
    routingPolicyGroup
  } = redirect;
  const routingPolicyToUpdate = getRoutingPolicyAtIndex(routingPolicyGroup, routingPolicyIndex);
  if (routingPolicyToUpdate) {
    const newPolicy = Object.assign({}, routingPolicyToUpdate, {
      routingPolicyList: removeItemFromArray(routingPolicyToUpdate.routingPolicyList, routingListIndex)
    });
    const newRoutingPolicyGroup = updateItemInArray(routingPolicyGroup, routingPolicyIndex, newPolicy);
    return Object.assign({}, redirect, {
      routingPolicyGroup: newRoutingPolicyGroup
    });
  }
  return redirect;
};
export const appendRoutingList = (redirect, routingPolicyIndex) => {
  const {
    routingPolicyGroup
  } = redirect;
  const routingPolicyToUpdate = getRoutingPolicyAtIndex(routingPolicyGroup, routingPolicyIndex);
  if (routingPolicyToUpdate && routingPolicyToUpdate.routingPolicyList.length < MAX_ROUTING_LISTS_PER_POLICY) {
    const identifier = getPolicyPropertyIdentifier(routingPolicyToUpdate);
    let objectTypeId;
    let propertyName;
    if (identifier) {
      [objectTypeId, propertyName] = splitPolicyPropertyIdentifier(identifier);
    }
    const newRoutingPolicyList = objectTypeId && propertyName ? Object.assign({}, DEFAULT_FILTER_BRANCH, {
      routingPolicyFilter: Object.assign({}, DEFAULT_FILTER_BRANCH.routingPolicyFilter, {
        objectTypeId,
        propertyName
      })
    }) : DEFAULT_FILTER_BRANCH;
    const newPolicy = Object.assign({}, routingPolicyToUpdate, {
      routingPolicyList: [...routingPolicyToUpdate.routingPolicyList, newRoutingPolicyList]
    });
    const newRoutingPolicyGroup = updateItemInArray(routingPolicyGroup, routingPolicyIndex, newPolicy);
    return Object.assign({}, redirect, {
      routingPolicyGroup: newRoutingPolicyGroup
    });
  }
  return redirect;
};
const isRoutingPolicyFieldsValid = routingPolicyList => {
  const {
    routingPolicyFilter
  } = routingPolicyList;
  const {
    objectTypeId,
    propertyName
  } = routingPolicyFilter;
  return objectTypeId && propertyName;
};
const isRoutingPolicyRouteValid = routingPolicyList => {
  const {
    routeType,
    routeValue
  } = routingPolicyList;
  switch (routeType) {
    case ROUTE_TYPE.EXTERNAL_URL:
      return !!routeValue && isValidUrl(routeValue);
    case ROUTE_TYPE.MEETING:
    case ROUTE_TYPE.HUBSPOT_PAGE:
      return !!routeValue;
    default:
      return false;
  }
};
const isRoutingPolicyConditionValid = routingPolicyList => {
  const {
    routingPolicyFilter
  } = routingPolicyList;
  const {
    propertyFilterOperation
  } = routingPolicyFilter;
  const {
    propertyType,
    operator
  } = propertyFilterOperation;
  return propertyType && operator;
};
const isRoutingPolicyListValid = routingPolicyList => {
  const routeValid = isRoutingPolicyRouteValid(routingPolicyList);
  const {
    routingPolicyFilter
  } = routingPolicyList;
  const {
    objectTypeId,
    propertyName,
    propertyFilterOperation
  } = routingPolicyFilter;
  const {
    propertyType,
    operator
  } = propertyFilterOperation;
  const formFieldSelected = objectTypeId && propertyName;
  const operationSelected = propertyType && operator;
  return routeValid && formFieldSelected && operationSelected;
};
const isRoutingPolicyGroupValid = routingPolicyGroup => routingPolicyGroup.routingPolicyList.every(list => isRoutingPolicyListValid(list));
const isRoutingPolicyGroupFieldsValid = routingPolicyGroup => routingPolicyGroup.routingPolicyList.every(list => isRoutingPolicyFieldsValid(list));
const isRoutingPolicyGroupRoutesValid = routingPolicyGroup => routingPolicyGroup.routingPolicyList.every(list => isRoutingPolicyRouteValid(list));
const isRoutingPolicyGroupConditionsValid = routingPolicyGroup => routingPolicyGroup.routingPolicyList.every(list => isRoutingPolicyConditionValid(list));
export const validateFormRoutingFields = formRouting => {
  const allPolicyGroupsValid = formRouting.routingPolicyGroup.every(group => isRoutingPolicyGroupFieldsValid(group));
  return allPolicyGroupsValid;
};
export const validateFormRoutingRoutes = formRouting => {
  const allPolicyGroupsValid = formRouting.routingPolicyGroup.every(group => isRoutingPolicyGroupRoutesValid(group));
  return allPolicyGroupsValid;
};
export const validateFormRoutingDefaultRoutes = formRouting => {
  const defaultRouteType = formRouting.defaultRouteType;
  const defaultRouteValue = formRouting.defaultRouteValue;
  switch (defaultRouteType) {
    case FALLBACK_TYPES.MEETING:
    case FALLBACK_TYPES.HUBSPOT_PAGE:
    case FALLBACK_TYPES.INLINE_MESSAGE:
      return !!defaultRouteValue;
    case FALLBACK_TYPES.EXTERNAL_URL:
      return !!defaultRouteValue && isValidUrl(defaultRouteValue);
    default:
      return false;
  }
};
export const validateFormRoutingConditions = formRouting => {
  const allPolicyGroupsValid = formRouting.routingPolicyGroup.every(group => isRoutingPolicyGroupConditionsValid(group));
  return allPolicyGroupsValid;
};
export const validateFormRouting = formRouting => {
  const isRoutingDisabled = formRouting.routeState === ROUTE_STATE.DISABLED;
  const isDefaultRouteValueValid = isRoutingDisabled || validateFormRoutingDefaultRoutes(formRouting);
  const defaultRouteValid = formRouting.defaultRouteType && isDefaultRouteValueValid && formRouting.routeState;
  const formIdPresent = !!formRouting.formId;
  const isConditionalRouting = formRouting.routeState === ROUTE_STATE.CONDITIONAL_ROUTE;
  const allPolicyGroupsValid = formRouting.routingPolicyGroup.every(group => isRoutingPolicyGroupValid(group));
  const isConditionsValid = !isConditionalRouting || allPolicyGroupsValid;
  return defaultRouteValid && formIdPresent && isConditionsValid;
};
export const getDefaultMeetingIdFromRouting = formRouting => {
  const meetingIdFromDefaultRoute = formRouting.defaultRouteType === FALLBACK_TYPES.MEETING && formRouting.defaultRouteValue;
  if (meetingIdFromDefaultRoute) {
    return Number(meetingIdFromDefaultRoute);
  }
  const {
    routingPolicyGroup
  } = formRouting;
  const firstList = getRoutingPolicyListAtIndex(routingPolicyGroup, 0, 0);
  if (firstList && firstList.routeType === ROUTE_TYPE.MEETING && firstList.routeValue) {
    return Number(firstList.routeValue);
  }
  return undefined;
};
export const getListsFromRouting = formRouting => {
  return flatten(formRouting.routingPolicyGroup.map(policyGroup => policyGroup.routingPolicyList));
};
export const getNumberOfListsFromRouting = formRouting => getListsFromRouting(formRouting).length;
export const getNumberOfPoliciesFromRouting = formRouting => formRouting.routingPolicyGroup.length;
export const getRouteTypesFromRouting = formRouting => {
  return formRouting.routingPolicyGroup.flatMap(routingPolicy => routingPolicy.routingPolicyList.map(list => list.routeType));
};
export const getIsRoutingEnabled = formRouting => formRouting.routeState !== ROUTE_STATE.DISABLED;
export const getPolicyIndicesWithTicketProperties = formRouting => {
  return formRouting.routingPolicyGroup.reduce((indicies, group, currentIndex) => {
    if (getIsPolicyTicketProperty(group)) {
      indicies.push(currentIndex);
    }
    return indicies;
  }, []);
};
export const getPolicyIndicesWithIdentifier = (formRouting, identifier) => {
  return formRouting.routingPolicyGroup.reduce((indices, group, currentIndex) => {
    const groupIdentifier = getPolicyPropertyIdentifier(group);
    if (identifier === groupIdentifier) {
      indices.push(currentIndex);
    }
    return indices;
  }, []);
};
export const getPolicyWithIdentifier = (formRouting, identifier) => {
  const index = getPolicyIndicesWithIdentifier(formRouting, identifier)[0];
  const {
    routingPolicyGroup
  } = formRouting;
  return getRoutingPolicyAtIndex(routingPolicyGroup, index);
};
export const listContainsField = (lists, objectTypeId, name) => lists.some(list => list.routingPolicyFilter.objectTypeId === objectTypeId && list.routingPolicyFilter.propertyName === name);
export const listContainsTicketField = lists => lists.some(list => list.routingPolicyFilter.objectTypeId === FormFieldPropertyObjectTypesIds.TICKET);
export const getFieldIdentifiersUsedInRouting = formRouting => {
  const identifiers = formRouting.routingPolicyGroup.map(group => getPolicyPropertyIdentifier(group));
  // typesafe solution
  const filtered = identifiers.flatMap(id => id ? [id] : []);
  return filtered;
};